<script></script>

<main>
    <div class="section">
        <div class="columns is-centered">
            <div class="column is-8-tablet is-6-widescreen">
                <div class="container">
                    <h1 class="title is-1">About GachAni</h1>
                    <p class="my-3">
                        GachAni is intended to be a simple app for helping you
                        find your next Anime to watch. GachAni lets you browse
                        popular shows and movies as well as search for your
                        favorites, providing a simple recomendation system
                        powered by MAL(MyAnimeList.net).
                    </p>
                    <p>
                        GachAni was created by me, <a
                            href="https://github.com/fuzzylimes"
                            target="_blank">fuzzylimes</a
                        >, as a fun side project to flush out a new MAL library
                        that I was working on. I figured people are always
                        looking for recommendations, and having something
                        outside of the MAL website would be nice to have.
                    </p>
                </div>
                <div class="container mt-5">
                    <h3 class="title is-3">Credits</h3>
                    <ul>
                        <li>
                            <a href="https://myanimelist.net" target="_blank"
                                >MyAnimeList</a
                            > - provides API and owns all data displayed on this
                            website
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</main>

<style></style>
